import { useEffect, useState } from 'react'
import { Modal, Typography, Button } from '@frontend/design_system'
import { useAppSelector } from 'redux/hooks'
import { menuSectionsNotCompletedSelector } from 'redux/login/selectors'
import { ONBOARDING_INCOMPLETE_COOKIE_KEY } from 'constants/cookies'
import { cookiesService } from 'utils/cookiesService'
import styles from './styles.module.scss'
import { ONBOARDING_MODAL } from 'texts/onboarding'

export const OnboardingModal = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const menuSectionsNotCompleted = useAppSelector(
    menuSectionsNotCompletedSelector
  )

  useEffect(() => {
    if (typeof menuSectionsNotCompleted === 'object') {
      const hasIncompleteSections = cookiesService.get(
        ONBOARDING_INCOMPLETE_COOKIE_KEY
      )
      if (!menuSectionsNotCompleted?.length && hasIncompleteSections) {
        setModalOpen(true)
        cookiesService.remove(ONBOARDING_INCOMPLETE_COOKIE_KEY)
      }
    }
  }, [menuSectionsNotCompleted])

  const handleClose = () => {
    setModalOpen(false)
  }

  return isModalOpen ? (
    <Modal
      position="center-horizontal"
      title={ONBOARDING_MODAL.TITLE}
      headerSize="large"
      isDelimiter
      dataTestId="onboarding-modal"
    >
      <div className={styles['modal-content']}>
        <div className={styles['modal-content-description']}>
          <Typography name="Button1" color="grey500" Tag="p">
            {ONBOARDING_MODAL.DESCRIPTION}
          </Typography>
          <Typography name="Button1" color="grey500" Tag="p">
            {ONBOARDING_MODAL.DETAIL}
          </Typography>
        </div>
        <Button
          label={ONBOARDING_MODAL.BUTTON}
          size="large"
          onClick={handleClose}
          dataTestId="onboarding-modal-confirm-button"
        />
      </div>
    </Modal>
  ) : null
}
